import React, { useState, useEffect } from 'react'
import { getOverdueEMIPortfolioAPI } from '../DebtListActionCreator';
import Loader from '../../../../presentationals/Loader/Loader.component';

export default function LoanPortfolioReview({nbfcId, applyFilter, clearApplyFilter,productSelected}) {
    const [loader, setLoader] = useState(false);
    const [nbfcFilter, setnbfcFilter] = useState("")
    const [productFilter, setproductFilter] = useState("")
    const [portfolioData, setPortfolioData] = useState([])
    const [portfolioTotalData, setPortfolioTotalData] = useState({})

    useEffect(()=>{
        APIFunction('',"")
    },[])

    useEffect(() => {
        setnbfcFilter(nbfcId)
        setproductFilter(productSelected)
        if(applyFilter == true){
            APIFunction(nbfcId,productFilter)
        }
    }, [nbfcId,applyFilter,productSelected])

    const APIFunction = (nbfcIdValue,productFilter) => {
        getOverdueEMIPortfolioFunction(nbfcIdValue,productFilter)
    }

    const textNullfn = (text) => {
        if (text == null || text == undefined || text == '') {
            return '-'
        } else {
            return text;
        }
    }
   
    const getOverdueEMIPortfolioFunction = (nbfcIdValue,productFilter) => {
        setLoader(true)
        getOverdueEMIPortfolioAPI(nbfcIdValue, productFilter, (callback) => {
            setLoader(false)
            console.log(callback)
            clearApplyFilter()
            if (callback && callback?.status == 200) {
                setPortfolioData(callback?.data?.data)
                setPortfolioTotalData(callback?.data?.total)
            }
        })
    }
    return (
        <>
<div className="LoanPortfolio" style={{ borderRadius: '16px', padding: '20px'}}>
            {
                loader ?
                    <Loader />
                    : ''
            }
            
            <div className="phocket-table-new TableNew" style={{marginTop:'0'}}>
                <table>
                    <thead>
                        <tr>
                            <th>OverDue Days</th>
                            <th>Number Of EMI</th>
                            <th>Overdue Amount</th>
                            <th>Principal</th>
                            <th>Interest</th>
                            <th>Penalty</th>
                            <th>Bounce</th>
                        </tr>
                    </thead>
                    <tbody>
                        {portfolioData?.map((data, index) => (
                            <tr key={index}>
                                <td>{textNullfn(data.interval)}</td>
                                <td>{textNullfn(data.emiCount)?.toLocaleString("en-IN") || 0}</td>
                                <td>{textNullfn(data.overdueAmount)?.toLocaleString("en-IN") || 0}</td>
                                <td>{textNullfn(data.principal)?.toLocaleString("en-IN") || 0}</td>
                                <td>{textNullfn(data.interest)?.toLocaleString("en-IN") || 0}</td>
                                <td>{textNullfn(data.penalty)?.toLocaleString("en-IN") || 0}</td>
                                <td>{textNullfn(data.bounce)?.toLocaleString("en-IN") || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                    <thead>
                        <tr>
                            <th>Total</th>
                            <th>{textNullfn(portfolioTotalData.totalCount)?.toLocaleString("en-IN") || 0}</th>
                            <th>{textNullfn(portfolioTotalData.totalOverdue)?.toLocaleString("en-IN") || 0}</th>
                            <th>{textNullfn(portfolioTotalData.totalPrincipal)?.toLocaleString("en-IN") || 0}</th>
                            <th>{textNullfn(portfolioTotalData.totalInterest)?.toLocaleString("en-IN") || 0}</th>
                            <th>{textNullfn(portfolioTotalData.totalPenalty)?.toLocaleString("en-IN") || 0}</th>
                            <th>{textNullfn(portfolioTotalData.totalBounce)?.toLocaleString("en-IN") || 0}</th>
                        </tr>
                    </thead>
                </table>
            </div>
            </div>

        </>
    )
}
